/**
* @name: xm-menu-item
* @author: weiyong
* @date: 2023-05-13 19:15
* @description：xm-menu-item
* @update: 2023-05-13 19:15
*/
<template>
  <a-sub-menu class="xm-menu-sub" :key="menuItem.id" >
    <template #icon>
      <xm-menu-li class="flex-div" @click="openMenu" :activeItem="isActiveItem(menuItem.id)" :openFlag="true" :menuItem="menuItem"/>
    </template>

    <template v-for="sonMenuItem in menuItem.children">
      <!--子菜单-->
      <xm-menu-sub v-if="sonMenuItem.type==='menu'" :list="sonMenuItem.children" :activeItem="isActiveItem(sonMenuItem.id)" :openFlag="openFlag" :menuItem="sonMenuItem"/>
      <!--界面-->
      <a-menu-item v-if="sonMenuItem.type==='page'"  :key="String(sonMenuItem.id || sonMenuItem.path)" class="el-custom-sidebar-item">
        <template #icon>
          <xm-menu-li :activeItem="isActiveItem(String(sonMenuItem.id || sonMenuItem.path))" :openFlag="openFlag" :menuItem="sonMenuItem"/>
        </template>
        <span v-if="openFlag===false">{{ sonMenuItem.label||sonMenuItem.name }}</span>
      </a-menu-item>
    </template>
  </a-sub-menu>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {createAsyncComponent} from "@/utils/factory/createAsyncComponent";

export default defineComponent({
  components: {
    xmMenuSub: createAsyncComponent(() => import('../components/xm-menu-sub.vue')),
  },
  name: "xm-menu-item",
});
</script>

<script lang="ts" setup>
import {SubMenu as aSubMenu,MenuItem as aMenuItem} from "ant-design-vue";
import XmMenuLi from "@/layouts/layoutFrame/scaLayout/components/xm-menu-li.vue";
import {useDesign} from "@/hooks/web/useDesign";
const {prefixCls} = useDesign('xm-menu-item');

interface IProps{
  pItem:any,
  menuItem:any,
  openFlag:boolean,
  selectedKeys:any
}
const props=withDefaults(defineProps<IProps>(),{
  menuItem:{},
  pItem:{},
  openFlag:false,
  selectedKeys:[]
});
const {selectedKeys}=toRefs(props);

const isActiveItem=function (key){
  const activeItem = unref(selectedKeys).filter((itemDb) => {
    return key === itemDb
  })[0];
  if (activeItem) {
    return true;
  } else {
    return false;
  }
}

const emits=defineEmits(
  ['openMenu']
);
const openMenu=function (){
  emits("openMenu",props.menuItem,props.pItem);
}

</script>

<style type="text/css" lang="less">
.xm-menu-sub{
  .ant-menu-item-icon{
    .item-icon{
      padding-right: 8px;
    }
  }
}
</style>
